import _extends from "@babel/runtime/helpers/extends";
import * as utils from './utils';
import components, { install } from './components';
import Api, { http, getMedia } from './api/main';
var DdOpenData = components.DdOpenData,
    OpenData = components.OpenData,
    UserName = components.UserName,
    PositionName = components.PositionName,
    DeptName = components.DeptName,
    OpenDataMatch = components.OpenDataMatch,
    OpenDataHtml = components.OpenDataHtml;
export * from './utils';
export { DdOpenData, OpenData, UserName, PositionName, DeptName, install, Api, http, getMedia, OpenDataMatch, OpenDataHtml };

var yxtOpenData = _extends({
  install: install
}, components, utils, {
  Api: Api,
  http: http,
  getMedia: getMedia,
  // @ts-ignore
  version: "2.0.26"
}); // @ts-ignore


console.log("%c[yxt-open-data] current version: " + "2.0.26", 'color: green;');
var isDebug = /debug=yes/i.test(window.location.href) || window.localStorage.debug * 1 > 0;

if (isDebug) {
  console.log('DEBUGING yxt-open-data'); // @ts-ignore

  window.yxtOpenData = yxtOpenData;
}

export default yxtOpenData;